<template>
  <div class="text-block">
    <header class="text-block__header">
      <h3 class="text-block__title">{{ title }}</h3>
    </header>
    <div class="photo-block__text" v-html="html"></div>
  </div>
</template>

<script>
export default {
  name: 'TextBlock',
  props: {
    html: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    titleRu: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="sass">
.text-block
  padding: 0 15px

.text-block__header
  display: flex
  flex-flow: row nowrap
  justify-content: space-between
  align-items: center
  margin-bottom: 30px

.text-block__title
  font-size: 24px
  font-weight: 500
  padding: 0
  margin: 0

</style>
